/**
 * Hash router for the console. Routes map 1:1 to the pages listed in the
 * delivery plan; unknown routes render NotFound.
 */

export interface RouteMatch {
  readonly page: string;
  readonly params: Record<string, string>;
}

const ROUTES: readonly { pattern: RegExp; page: string }[] = [
  { pattern: /^#?\/?setup$/u, page: "setup" },
  { pattern: /^#?\/?routes$/u, page: "routes" },
  { pattern: /^#?\/?policies$/u, page: "policies" },
  { pattern: /^#?\/?decisions$/u, page: "decisions" },
  { pattern: /^#?\/?quota$/u, page: "quota" },
  { pattern: /^#?\/?cache$/u, page: "cache" },
  { pattern: /^#?\/?privacy$/u, page: "privacy" },
  { pattern: /^#?\/?credentials$/u, page: "credentials" },
  { pattern: /^#?\/?billing$/u, page: "billing" },
  { pattern: /^#?\/?security$/u, page: "security" },
  { pattern: /^#?\/?evals$/u, page: "evals" },
];

export function routeOf(hash: string): RouteMatch {
  for (const route of ROUTES) {
    if (route.pattern.test(hash)) return { page: route.page, params: {} };
  }
  return { page: "notfound", params: {} };
}

export const PAGE_NAMES: readonly string[] = [
  "setup",
  "routes",
  "policies",
  "decisions",
  "quota",
  "cache",
  "privacy",
  "credentials",
  "billing",
  "security",
  "evals",
];
